<template>
  <div>
    <van-nav-bar
      left-arrow
      :title="title"
      left-text="返回"
      @click-left="hide">
    </van-nav-bar>
    <div style="margin-top: 10px;font-size: 16px;">
      <div>
        <label class="label">车主姓名</label>
        <label v-if="work.ownerName" class="value">{{work.ownerName}}</label>
        <label v-else style="color: #646464;" class="value">无</label>
      </div>
      <div>
        <label class="label">车牌</label><label class="value">{{work.carNo | carNo}}</label>
      </div>
      <div>
        <label class="label">品牌/车型</label><label class="value">{{work.brandName}} / {{work.model}}</label>
      </div>
      <div>
        <label class="label">服务顾问</label><label class="value">{{work.consultantName}}</label>
      </div>
      <div>
        <label class="label">到厂时间</label><label class="value">{{work.enterTime}}</label>
      </div>
      <div>
        <label class="label">交车时间</label>
        <label class="value">{{work.estimateDeliveryTime}}</label>
      </div>
      <div>
        <label class="label">验收结果</label>
        <remote-picker select-first
                       class="value"
                       :options="qualityResults"
                       v-model="request.qualified">
        </remote-picker>
      </div>
      <div v-show="!this.request.qualified">
        <label class="label">返工工序</label>
        <remote-picker class="value"
                       v-model="request.prevProcedureId"
                       :options="dispatchProcedureList">
        </remote-picker>
      </div>
      <div v-show="this.request.qualified">
        <label class="label">下个工序</label>
        <remote-picker select-first
                       class="value"
                       class-name="ActiveProcedureAfterQuality"
                       v-model="request.nextProcedureId">
        </remote-picker>
      </div>
      <div style="display: flex; margin-top: 10px">
        <label class="label" style="flex-shrink: 0">备注</label>
        <el-input style="display: inline-block; margin-right: 50px" type="textarea" v-model="request.remarks" :rows="3"
                  maxlength="200"
                  class="value"
                  resize="none"
                  :placeholder="this.request.qualified ? '' : '返工原因描述'">
        </el-input>
      </div>
      <div style="text-align: center; margin-top: 56px">
        <template v-if="!request.qualified">
          <div v-for="procedure of dispatchProcedureList" :key="procedure.id"
               style="font-size: 14px; color: gray; display: flex; justify-content: center">
            <label style="width: 60px">{{procedure.text | trim}}</label>
            <label style="width: 100px">{{procedure.technicianName}}</label>
          </div>
        </template>
        <van-button style="margin-top: 16px; width: 60%" size="normal" type="info" @click="confirm">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button, Field, NavBar, Toast } from 'vant'
  import RemotePicker from '@/components/selector/RemotePicker'
  import { dispatchWorkProcedures, qualityInspect } from '@/utils/request'

  function Request () {
    this.workId = null
    this.qualified = false
    this.prevProcedureId = null
    this.nextProcedureId = null
    this.remarks = null
  }

  const lodash = require('lodash')

  export default {
    name: 'WxQualityInspectPage',
    components: {
      RemotePicker,
      [NavBar.name]: NavBar,
      [Field.name]: Field,
      [Button.name]: Button
    },
    props: {
      show: Boolean,
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        dispatchProcedureList: [],
        request: new Request(),
        qualityResults: [
          {
            id: false,
            text: '不合格'
          }, {
            id: true,
            text: '合格'
          }
        ]
      }
    },
    methods: {
      hide () {
        this.$emit('update:show', false)
      },
      debounceOpen: lodash.debounce(function () {
        this.request.workId = this.work.id
        dispatchWorkProcedures(this.work.id).then(response => {
          this.dispatchProcedureList = response.data.map(procedure => {
            return {
              id: procedure.id,
              text: procedure.name,
              technicianName: procedure.technicianName
            }
          })
        }).finally(() => {
          this.loading = false
        })
      }, 500),
      debounceClose: lodash.debounce(function () {
      }, 500),
      confirm () {
        if (!this.request.qualified && !this.request.prevProcedureId) {
          Toast.fail('请选择返工工序！')
          return
        }
        this.request.workId = this.work.id
        this.work.loading = true
        qualityInspect(this.$_.cloneDeep(this.request))
          .then(() => this.hide())
          .catch(() => {
            this.work.loading = false
          })
      }
    },
    computed: {
      title () {
        return '施工单验收'
      }
    },
    watch: {
      show: {
        handler (value) {
          this.request = new Request()
          this.dispatchProcedureList = []
          if (value) {
            this.debounceOpen()
          } else {
            this.debounceClose()
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label {
    font-size: 15px;
    display: inline-block;
    width: 120px;
    color: #646464;
    text-align: right;
    height: 40px;
    line-height: 40px;
  }

  .value {
    font-size: 16px;
    display: inline-block;
    color: black;
    height: 40px;
    line-height: 40px;
    margin-left: 34px;
  }
</style>
